import { type COLORS, getColorByString } from "../colors";
import { snakeCase } from "../strings";
import type { Absence } from "../types";

/**
 * This function returns a calculated color for the absence type.
 */
export function getAbsenceTypeColor(type: Absence["type"]): (typeof COLORS)[number] {
	return getColorByString(snakeCase(type));
}
